import { connectHook } from 'app/common/components/connect-hook';
import { Search } from './search.js';
import { useSearch } from './search-hook.js';

export default connectHook(Search, useSearch);
